import { render } from "./VabeneAddRestaurant.vue?vue&type=template&id=0f80e498&ts=true"
import script from "./VabeneAddRestaurant.vue?vue&type=script&lang=ts"
export * from "./VabeneAddRestaurant.vue?vue&type=script&lang=ts"

import "./VabeneAddRestaurant.vue?vue&type=style&index=0&id=0f80e498&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__